export const FFV = "ffv"
export const ASA = "asa"
export const AUSA = "ausa"
export const CANADA = "canada"
export const FFYB = "ffyb"
export const RYA_MCA = "rya_mca"
